export enum UserAvatarMode {
  default = 'default',
  preview = 'preview',
  dropdown = 'dropdown',
  selection = 'selection',
}
